<template>
    <div>
        <div v-if="avatars.length > 1">
            <div v-if="!extended" class="avatar-group py-1 d-flex align-items-center" :class="avatarGroupClass" @click.prevent="extendedChange('more')">
                <template v-for="(avatar, index) in avatars" >
                    <img :key="index" v-if="avatar.img" :src="avatar.img" class="rounded-circle"
                        :class="{ 'avatar-bordered': border, 'avatar-shadow': shadow }"
                        :alt="avatar.alt ? avatar.alt : $t('not_found')" />
                    <div  v-else class="no-img rounded-circle" :key="index"
                        :class="{ 'avatar-bordered': border, 'avatar-shadow': shadow }">
                        <small>{{ avatar.title ? avatar.title : 'AV' | titleFilter }}</small>
                    </div>
                </template>
                <a class="pl-2 pr-2 text-muted">
                    <small>{{ $t('more_gantt_users') }}</small>
                </a>
            </div>



            <div v-else class="row animate__animated animate__fadeIn">
                <div class="col-12 d-flex justify-content-between">
                    <div class="avatar-group-extended">
                        <div v-for="(avatar, index) in avatars" :key="index" class="media d-flex align-items-center py-1">
                            <div :class="avatarGroupClass">
                                <img class="rounded-circle" v-if="avatar.img"
                                    :class="{ 'avatar-bordered': border, 'avatar-shadow': shadow }" :src="avatar.img"
                                    :alt="avatar.alt ? avatar.alt : $t('not_found')">
                                <div v-else class="no-img rounded-circle"
                                    :class="{ 'avatar-bordered': border, 'avatar-shadow': shadow }">
                                    <small>{{ avatar.title ? avatar.title : 'AV' | titleFilter }}</small>
                                </div>
                            </div>
                            <div class="media-body ml-2">
                                <small>{{ avatar.title }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="mt-2 cursor-pointer" @click.prevent="extendedChange('short')">
                        <app-icon :name="'maximize-2'" />
                    </div>
                </div>
            </div>

        </div>
        <div v-else>
            <div class="avatar-group-extended" :class="avatarGroupClass">
                <div v-for="(avatar, index) in avatars" :key="index" class="media d-flex align-items-center py-1">
                    <div :class="avatarGroupClass">
                        <img v-if="avatar.img" :src="avatar.img" class="rounded-circle"
                            :class="{ 'avatar-bordered': border, 'avatar-shadow': shadow }"
                            :alt="avatar.alt ? avatar.alt : $t('not_found')" />
                        <div v-else class="no-img rounded-circle"
                            :class="{ 'avatar-bordered': border, 'avatar-shadow': shadow }">
                            <small>{{ avatar.title ? avatar.title : 'AV' | titleFilter }}</small>
                        </div>
                    </div>
                    <div class="media-body ml-2">
                        <small>{{ avatar.title }}</small>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AvatarsGroup",
    props: {
        avatarGroupClass: {
            type: String,
            default: 'avatars-group-w-30'
        },
        avatars: {
            type: Array,
            required: true
        },
        shadow: {
            type: Boolean,
            default: false
        },
        border: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            extended: false
        }
    },
    methods: {
        extendedChange(type){
            if(type == 'more'){
                this.extended = true;
            }else{
                this.extended = false;
            }
           
        }
    },
    filters: {
        titleFilter(str) {
            str = str.replace(/(^\s*)|(\s*$)/gi, "");
            str = str.replace(/[ ]{2,}/gi, " ");
            str = str.replace(/\n /, "\n");
            let titleArray = str.split(' ');
            if (titleArray.length > 1) {
                return (titleArray[0][0] + titleArray[1][0]).toLocaleUpperCase();
            } else {
                return titleArray[0].substring(0, 2).toLocaleUpperCase();
            }
        },
    }
}
</script>
